// extracted by mini-css-extract-plugin
module.exports = {"FeaturedProducts":"FeaturedProducts_FeaturedProducts___Rtb2","list":"FeaturedProducts_list__MkULP"};